// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3DTb_","productName":"Table_productName__3gB18"};